module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg17-01c57c0270dbcd8ce0c5d4a45ae95100.png";